import { Button, Col, Form, Input, Row, Select, Spin, Switch } from 'antd';
import isEmpty from 'lodash/isEmpty';
import sortBy from 'lodash/sortBy';
import React, { useEffect, useState } from 'react';

import { ReactSVG } from 'react-svg';
import { DAY_NAME, LOCATION_TYPE, ROLES, TYPE_PAGE } from '../../../constants';

import AddressInput from '../../Inputs/AddressInput';
import './Location.scss';

const initValuesForm = {
  region: 'Amsterdam',
  locationType: LOCATION_TYPE['STORE'],
  isActive: true,
  address: {},
};

const initHoursData = {
  start: null,
  end: null,
  isValid: true,
};
const dayOfWeeks = Object.keys(DAY_NAME);
const initPickupHours = {};
const initPickupHoursData = {};
dayOfWeeks?.forEach((day) => {
  initPickupHours[day] = false;
  initPickupHoursData[day] = initHoursData;
});

const LocationForm = ({
  handleCancel,
  handleOk,
  location,
  companies = [],
  users,
  isModalOpen,
  isFetching,
  typePage = TYPE_PAGE.DRAFT,
}) => {
  const [formLocation] = Form.useForm();
  // const [pickupHours, setPickupHours] = useState(initPickupHours);
  const [pickupHoursData, setPickupHoursData] = useState(initPickupHoursData);

  useEffect(() => {
    if (location) {
      formLocation.setFieldsValue({
        ...location,
        locationUsers: location?.locationUsers?.map((lu) => lu.userId) || [],
        deliveryAreas: location?.deliveryAreas?.map((area) => area.id),
        address: {
          address: location.address,
          latLng: {
            lat: location.addressLat,
            lng: location.addressLng,
          },
        },
      });
      const newPickupHours = {};
      dayOfWeeks?.forEach((day) => {
        const start = location.pickupHours[day].start;
        const end = location.pickupHours[day].end;
        newPickupHours[day] = !!start || !!end;
      });
      setPickupHoursData(location.pickupHours);
      // setPickupHours(newPickupHours);
    } else {
      formLocation.resetFields();
      // setPickupHours(initPickupHours);
      setPickupHoursData(initPickupHoursData);
    }
  }, [formLocation, location, isModalOpen]);

  const onFinishForm = (values) => {
    if (Object.values(pickupHoursData).find((element) => !element.isValid)) return;
    const address = values.address;

    const params = { ...values };
    params.address = address.addressObject;
    params.addressLat = address.latLng.lat;
    params.addressLng = address.latLng.lng;
    params.pickupHours = { ...pickupHoursData };

    if (!params.locationUsers?.length) {
      delete params.locationUsers;
    }

    if (typePage != TYPE_PAGE.DRAFT) params.companyId = values.companyId;

    handleOk && handleOk(params);
  };

  const onCancel = () => {
    handleCancel && handleCancel();
  };

  // const changeTimeForHour = (key, type, value) => {
  //   if (!pickupHoursData[key]) return;

  //   const newPickupHoursData = {
  //     ...pickupHoursData,
  //     [key]: {
  //       ...pickupHoursData[key],
  //       [type]: value?.format('HH:mm') || null,
  //     },
  //   };

  //   if (newPickupHoursData[key].start && newPickupHoursData[key].end) {
  //     const start = newPickupHoursData[key].start;
  //     const end = newPickupHoursData[key].end;
  //     newPickupHoursData[key]['isValid'] = moment(start, TIME_FORMAT).isBefore(moment(end, TIME_FORMAT));
  //   } else {
  //     newPickupHoursData[key][' '] = true;
  //   }

  //   setPickupHoursData(newPickupHoursData);
  // };

  const onOk = () => {
    formLocation.submit();
  };

  const filterOption = (input, option = null) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

  // const onClickPickupHour = (key) => {
  //   const preValue = pickupHours[key];
  //   const newPickupHours = { ...pickupHours };
  //   newPickupHours[key] = !pickupHours[key];
  //   if (preValue) {
  //     const newPickupHoursData = {
  //       ...pickupHoursData,
  //       [key]: initHoursData,
  //     };
  //     setPickupHoursData(newPickupHoursData);
  //   }
  //   setPickupHours(newPickupHours);
  // };

  return (
    <Spin spinning={isFetching}>
      <div className="LocationForm">
        <Form
          form={formLocation}
          scrollToFirstError
          layout="vertical"
          requiredMark={false}
          colon={false}
          className="FormContent"
          onFinish={onFinishForm}
          initialValues={initValuesForm}
        >
          <Row gutter={16}>
            {companies.length > 0 && (
              <Col span={24}>
                <Form.Item label="Company" name="companyId" rules={[{ required: true, message: 'Required' }]}>
                  <Select
                    options={sortBy(companies, 'name')?.map((company) => ({
                      value: company.id,
                      label: company.name,
                    }))}
                    showSearch
                    filterOption={filterOption}
                    disabled={typePage === TYPE_PAGE.EDIT}
                  />
                </Form.Item>
              </Col>
            )}
            <Col span={12}>
              <Form.Item label="Location type" name="locationType" rules={[{ required: true, message: 'Required' }]}>
                <Select
                  options={Object.keys(LOCATION_TYPE)?.map((key) => ({ value: LOCATION_TYPE[key], label: key }))}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <div className="switch-active">
                <Form.Item name="isActive" valuePropName="checked">
                  <Switch />
                </Form.Item>
                <div className="text">
                  <p>Active</p>
                </div>
              </div>
            </Col>
            {/* <Col span={24}>
              <Form.Item label="Region " name="region" rules={[{ required: true, message: 'Required' }]}>
                <Select
                  options={[
                    { label: 'Amsterdam', value: 'Amsterdam' },
                    { label: 'Den Haag', value: 'Den Haag' },
                    { label: 'Rotterdam', value: 'Rotterdam' },
                    { label: 'Utrecht', value: 'Utrecht' },
                    { label: 'Maastricht', value: 'Maastricht' },
                  ]}
                />
              </Form.Item>
            </Col> */}
            <Col span={24}>
              <Form.Item
                label="Address"
                name="address"
                rules={[
                  {
                    validator: (_, value) => {
                      if (value?.address && value?.latLng?.lat && value?.latLng?.lng) {
                        return Promise.resolve();
                      }

                      if (isEmpty(value?.address)) {
                        return Promise.reject(new Error('Required'));
                      }

                      return Promise.reject(new Error('Invalid'));
                    },
                  },
                ]}
              >
                <AddressInput
                  size="large"
                  placeholder="Address"
                  onSelect={(value) => formLocation.setFieldsValue({ address: value })}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label="Location Name" name="name" rules={[{ required: true, message: 'Required' }]}>
                <Input size="large" placeholder="Location Name" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Contact Person" name="contactPerson" rules={[{ required: true, message: 'Required' }]}>
                <Input size="large" placeholder="Contact Person" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Phone Number"
                name="phone"
                rules={[
                  { required: true, message: 'Required' },
                  {
                    pattern: /^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/,
                    message: 'Please enter a valid phone',
                  },
                ]}
              >
                <Input size="large" placeholder="Phone Number" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Support Email"
                name="supportEmail"
                rules={[{ type: 'email', message: 'Invalid Email' }]}
              >
                <Input size="large" placeholder="Support Email" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <div className="mt-8">
                <em>Wismo questions will be relayed here</em>
              </div>
            </Col>
            <Col span={24}>
              <Form.Item label="Location Users" name="locationUsers">
                <Select
                  mode="multiple"
                  size="large"
                  allowClear
                  options={users
                    .filter((user) => user.role === ROLES.LOCATION_USER)
                    .map((user) => ({
                      label: user.name,
                      value: user.id,
                    }))}
                />
              </Form.Item>
            </Col>

            {/* <Col span={24}>
              <div className="pickupHours">
                <label>Pickup Hours</label>
                <div className="hours-content">
                  {dayOfWeeks?.map((day) => (
                    <Button
                      key={'check' + day}
                      className={`content ${pickupHours[day] ? 'selected' : ''}`}
                      onClick={() => onClickPickupHour([day])}
                    >
                      {capitalize(day)}
                    </Button>
                  ))}
                </div>
              </div>
            </Col>
            {dayOfWeeks
              .filter((day) => pickupHours[day])
              ?.map((day) => (
                <Col span={24} key={day + 'data'}>
                  <TimesForDay
                    title={DAY_NAME[day]}
                    onChangeStartTime={(value) => changeTimeForHour(day, 'start', value)}
                    onChangeEndTime={(value) => changeTimeForHour(day, 'end', value)}
                    isValid={pickupHoursData[day].isValid}
                    start={pickupHoursData[day].start}
                    end={pickupHoursData[day].end}
                  />
                </Col>
              ))}*/}
            <Col span={24}>
              <label>Required for delivery</label>
              <div style={{ display: 'flex' }}>
                <Form.Item name="signature" style={{ marginTop: 8 }}>
                  <Switch />
                </Form.Item>
                <p style={{ marginLeft: 8 }}>Signature</p>
              </div>
              <div style={{ display: 'flex' }}>
                <Form.Item name="notAtNeighbour" style={{ marginTop: 8 }}>
                  <Switch />
                </Form.Item>
                <p style={{ marginLeft: 8 }}>Not at neighbour</p>
              </div>
            </Col>
          </Row>
        </Form>
        <div className="FormFooter">
          <Button className="ButtonCancel" onClick={onCancel}>
            Cancel
          </Button>
          <Button className="CreateButton ButtonPrimary" type="primary" onClick={onOk}>
            {location ? 'Edit' : 'Create'}
            <ReactSVG className="icon" src="/icons/done.svg" />
          </Button>
        </div>
      </div>
    </Spin>
  );
};

export default LocationForm;
